import { Specimen } from '@medplum/fhirtypes';
import { MedplumClient } from '@medplum/core';
import { useGenericResourceSearch } from '@/hooks/useGenericResourceSearch';
import {
  SPECIMEN_SEARCH_DEFAULTS,
  specimenSearchConfig,
  type SpecimenSearchParams,
} from '../specimens/specimenSearchConfig';

export type { SpecimenSearchParams };
export { SPECIMEN_SEARCH_DEFAULTS };

export function useSpecimenSearch(
  medplum: MedplumClient,
  patientId?: string
) {
  return useGenericResourceSearch<SpecimenSearchParams, Specimen>(
    medplum,
    specimenSearchConfig,
    patientId
  );
}
